module.exports = __webpack_public_path__ + "img/night_sky_lake_new.47904d35.jpg";